import types from '../types/deposit'
import {Map} from 'immutable'

const initialRoot = Map({
  step: 0,
  previousStep: 0,
  isFetching: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_STEP:
      return state.merge({
        step: action.payload.step,
        previousStep: state.get('step'),
      })
    case types.NEXT_STEP:
      let step = state.get('step') + 1
      if (step > 4) step = 0
      return state.merge({
        step: step,
        previousStep: state.get('step'),
      })
    case types.NEXT_STEP_FROM_START:
      return state.merge({
        step: action.payload.step,
      })
    case types.NEXT_STEP_FROM_ADDRESS:
      return state.merge({
        step: state.get('previousStep') !== 0 ? state.get('previousStep') : 2,
        previousStep: state.get('step'),
      })
    case types.NEXT_STEP_FROM_CARD:
      return state.merge({
        step: state.get('previousStep') !== 0 ? state.get('previousStep') : 4,
        previousStep: state.get('step'),
      })
    case types.NEXT_STEP_FROM_REVIEW:
      return state.merge(initialRoot)
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/deposit/reducers/deposit.js